import React, { useContext, useEffect, useState } from "react";

import { Grid, FormControlLabel, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";

import TextFieldErp from "../../components/basics/TextFieldErp";
import { updateCNDAgenda } from "../../repository/ERP/pub/CNDAgendaService";
import Title from "../../components/basics/Title";
import { CNDContext } from "../../context/CNDContext";
import Loading from "../../components/basics/Loading";
import ButtonErp from "../../components/basics/ButtonErp";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import { notify } from "../../utils/notify";
import { findCliente } from "../../repository/ERP/prouser/ClienteService";
import MaskService from "../../utils/mask/maskService";
import "./CND.css";

const idTipoCNDsefazSC = "12";

const CNDEdicao = ({ location }) => {
  const [ambito, setAmbito] = useState("");
  const [tipo, setTipo] = useState("");
  const [cnd, setCnd] = useState("");
  const [cpfResponsavelRequired, setCpfResponsavelRequired] = useState(false);
  const [cpfResponsavel, setCpfResponsavel] = useState("");
  const [aPartir, setAPartir] = useState("");
  const [diasAntecedenciaProxima, setDiasAntecedenciaProxima] = useState(0);
  const [diasAntecedenciaVencer, setDiasAntecedenciaVencer] = useState(0);
  const [clientesSelecionados, setClientesSelecionados] = useState([]);
  const [optionsClientes, setOptionsClientes] = useState([]);
  const [errors, setErrors] = useState({});
  const {
    optionsClientes: allOptionsClientes,
    loadingInputs,
    setLoadingInputs,
    setOptionsClientes: setAllOptionsClientes,
  } = useContext(CNDContext);
  const [loading, setLoading] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);
  const { goBack } = useHistory();

  useEffect(() => {
    const getCustomers = async () => {
      try {
        setLoadingInputs((prev) => ({ ...prev, clients: true }));

        const { data } = await findCliente(queryParams.empresa_cnpj, 100000);

        if (data && Array.isArray(data)) {
          setAllOptionsClientes([
            { razao: "TODOS", id: 0, ativo: "S" },
            ...data,
          ]);
        }
      } catch (error) {
        console.error("error CNDContext getCustomers", error);
      } finally {
        setLoadingInputs((prev) => ({ ...prev, clients: false }));
      }
    };

    if (
      !allOptionsClientes ||
      !Array.isArray(allOptionsClientes) ||
      allOptionsClientes.length < 1
    ) {
      getCustomers();
    }
  }, [
    queryParams.empresa_cnpj,
    allOptionsClientes,
    setAllOptionsClientes,
    setLoadingInputs,
  ]);

  useEffect(() => {
    if (allOptionsClientes && Array.isArray(allOptionsClientes)) {
      setOptionsClientes(
        allOptionsClientes.filter(
          (item) =>
            item.ativo !== "N" &&
            (item.id === 0 || MaskService.isValid("cnpj", item.cpfcnpj || ""))
        )
      );
    }
  }, [allOptionsClientes]);

  useEffect(() => {
    if (!location || !location.state) return;

    const row = JSON.parse(location.state);

    setClientesSelecionados(
      row.agendas_clientes && Array.isArray(row.agendas_clientes)
        ? allOptionsClientes.filter(
            (allItem) =>
              row.agendas_clientes.find(
                (item) =>
                  item.ativo !== "N" &&
                  (allItem.id || "").toString() ===
                    (item.id_cliente || "").toString()
              ) || false
          )
        : []
    );
    setAmbito(row.ambito);
    setTipo(row.tipo_consulta);
    setCnd(row.cnd);
    setAPartir(row.data_inicio);
    setDiasAntecedenciaProxima(row.consulta_antecedencia || 0);
    setCpfResponsavel(
      row.cpf_responsavel ? MaskService.toMask("cpf", row.cpf_responsavel) : ""
    );
    setCpfResponsavelRequired(row.id_cnd_tipo === idTipoCNDsefazSC);

    if (
      row.agendas_clientes &&
      Array.isArray(row.agendas_clientes) &&
      row.agendas_clientes[0]
    ) {
      setDiasAntecedenciaVencer(
        row.agendas_clientes[0].considerar_avencer || "0"
      );
    }

    setErrors({});
  }, [location, allOptionsClientes]);

  const handleChangeDiasAntecedencia = (e, setValue) => {
    if (!e.target.value) return setValue(0);

    if (e.target.value < 0) {
      return setValue(0);
    }
    if (e.target.value > 99) {
      return setValue(99);
    }

    setValue(e.target.value);
  };

  const handleChangeClientesSelecionados = (e, values) => {
    const indexTodos = values.findIndex(
      (value) => value.id === optionsClientes[0].id
    );

    if (indexTodos === values.length - 1 && values.length > 1) {
      return setClientesSelecionados([optionsClientes[0]]);
    } else if (indexTodos === 0 && values.length > 1) {
      values.splice(0, 1);
    }

    setClientesSelecionados(values);
  };

  const handleChangeCpfResponsavel = (e) => {
    setCpfResponsavel(MaskService.toMask("cpf", e.target.value));
  };

  const handleSubmit = async (e) => {
    try {
      setLoading(true);

      if (!location || !location.state) return;

      const row = JSON.parse(location.state);

      e.preventDefault();

      const errorsValidation = {};
      let isValidated = true;

      if (tipo === "Automática" && !aPartir) {
        isValidated = false;
        errorsValidation.aPartir = "Campo obrigatório";
      }

      if (clientesSelecionados.length < 1) {
        isValidated = false;
        errorsValidation.clientesSelecionados = "Campo obrigatório";
      }

      if (cpfResponsavelRequired) {
        if (!cpfResponsavel) {
          isValidated = false;
          errorsValidation.cpfResponsavel = "Campo obrigatório";
        } else if (!MaskService.isValid("cpf", cpfResponsavel)) {
          isValidated = false;
          errorsValidation.cpfResponsavel = "CPF inválido";
        }
      }

      if (!isValidated) {
        setErrors(errorsValidation);
        return notify("Verifique se os campos estão preenchidos corretamente.");
      }

      let clientesIds = clientesSelecionados.map((empresa) => empresa.id);
      if (clientesSelecionados[0].id === 0) {
        clientesIds = [];
        optionsClientes.forEach((empresa) => {
          if (empresa.id) clientesIds.push(empresa.id);
        });
      }

      const body = {
        empresa_cnpj: queryParams.empresa_cnpj,
        data_inicio: tipo === "Automática" ? aPartir : null,
        consulta_antecedencia: diasAntecedenciaProxima,
        vencer_antecedencia: diasAntecedenciaVencer,
        empresas: clientesIds,
      };

      if (cpfResponsavelRequired) {
        body.cpf_responsavel = cpfResponsavel;
      }

      const result = await updateCNDAgenda(
        body,
        row.id,
        queryParams.empresa_cnpj
      );

      if (result && result.success) {
        Swal.fire({
          icon: "success",
          text: result.msg,
          showConfirmButton: true,
          timer: 5000,
        });

        sessionStorage.setItem("tabCNDPainel", 0);
        return goBack();
      }

      notify("Não foi possível editar o registro.");
    } catch (error) {
      notify("Não foi possível editar o registro.");

      console.error("ERROR CNDEdicao handleSubmit", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loading open={loading} />
      <form onSubmit={handleSubmit}>
        <Grid container justify="center">
          <Grid
            item
            container
            spacing={2}
            xs={11}
            style={{
              background: "white",
              borderRadius: 10,
              marginTop: 20,
              padding: 5,
            }}
          >
            <Grid item xs={12}>
              <Title titulo="Edição de CNDs" />
            </Grid>

            <Grid item lg={4} md={4} sm={12} xs={12}>
              <TextFieldErp
                disabled
                helperText={errors.ambito}
                error={errors.ambito ? true : false}
                label="Âmbito"
                lg={2}
                value={ambito}
                setValue={setAmbito}
              />
            </Grid>

            <Grid item lg={4} md={4} sm={12} xs={12}>
              <TextFieldErp
                disabled
                helperText={errors.tipo}
                error={errors.tipo ? true : false}
                label="Tipo de Consulta"
                lg={2}
                value={tipo}
                setValue={setTipo}
              />
            </Grid>

            <Grid item lg={4} md={4} sm={12} xs={12}>
              <TextFieldErp
                disabled={!tipo || tipo !== "Automática"}
                helperText={errors.aPartir}
                error={errors.aPartir ? true : false}
                label="A partir de"
                type="date"
                value={aPartir}
                setValue={setAPartir}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TextFieldErp
                disabled
                helperText={errors.cnd}
                error={errors.cnd ? true : false}
                label="CND"
                lg={12}
                value={cnd}
                setValue={setCnd}
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              alignItems="center"
              container
            >
              <FormControlLabel
                control={
                  <label className="label-modal">
                    Próximas consultas com antecedênciade
                  </label>
                }
              ></FormControlLabel>
              <TextFieldErp
                value={diasAntecedenciaProxima}
                setValue={setDiasAntecedenciaProxima}
                onChange={(e) =>
                  handleChangeDiasAntecedencia(e, setDiasAntecedenciaProxima)
                }
                className="tab-cadastro-input-days"
                type="number"
              />
              <label className="label-dias">dias</label>
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              alignItems="center"
              container
            >
              <FormControlLabel
                control={
                  <label className="label-modal">
                    Situação "A Vencer" com antecendência de
                  </label>
                }
              ></FormControlLabel>
              <TextFieldErp
                value={diasAntecedenciaVencer}
                setValue={setDiasAntecedenciaVencer}
                onChange={(e) =>
                  handleChangeDiasAntecedencia(e, setDiasAntecedenciaVencer)
                }
                className="tab-cadastro-input-days"
                type="number"
              />

              <label className="label-dias">dias</label>
            </Grid>

            {cpfResponsavelRequired && (
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <TextFieldErp
                  helperText={errors.cpfResponsavel}
                  error={errors.cpfResponsavel ? true : false}
                  label="CPF do Responsável*"
                  value={cpfResponsavel}
                  setValue={setCpfResponsavel}
                  onChange={(e) => handleChangeCpfResponsavel(e)}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <Autocomplete
                loading={loadingInputs.clients || false}
                multiple
                size="small"
                options={Array.isArray(optionsClientes) ? optionsClientes : []}
                getOptionLabel={(option) => option.razao}
                value={clientesSelecionados}
                onChange={handleChangeClientesSelecionados}
                renderInput={(params) => {
                  if (optionsClientes.length === 0) {
                    params.InputProps.endAdornment = (
                      <CircularProgress color="inherit" size={20} />
                    );
                  }
                  return (
                    <TextField
                      helperText={errors.clientesSelecionados}
                      error={errors.clientesSelecionados ? true : false}
                      {...params}
                      variant="standard"
                      label="Clientes/Estabelecimentos (Com CNPJ válido)"
                      InputProps={{
                        ...params.InputProps,
                      }}
                    />
                  );
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              justify="flex-end"
              className="cnd-container-btns"
            >
              <ButtonErp
                cancel
                onClick={() => {
                  sessionStorage.setItem("tabCNDPainel", 0);
                  goBack();
                }}
              />
              <ButtonErp save type="submit" />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default CNDEdicao;
